/**
 * Determine if a username is for an Agent
 */
export const isAgt = (AgtNo: string | null | undefined) => {
  return Boolean(AgtNo && AgtNo.match(/^[a-zA-Z]{3}[0-9]{6}$/));
};
